import React from 'react';
import PropTypes from 'prop-types';

import Flash from '../../../../../../components/forms/Flash';
import Row from '../../../../../../components/Row';
import Column from '../../../../../../components/Column';
import { Label } from '../../../../../../components';

const EditInvoiceSettingsForm = ({
  values,
  handleSubmit,
  setFieldValue,
  errors,
  onModalClose,
}) => {
  const handleChange = ({ target }) => {
    const { id, value } = target;
    setFieldValue(id, value);
  };

  return (
    <form onSubmit={handleSubmit}>
      <Flash response={errors} />
      <Row>
        <Column className="with-bottom-space">
          <Label attr="contactPerson" text="Contact Person" />
          <input
            type="text"
            id="contactPerson"
            value={values.contactPerson}
            onChange={handleChange}
            required
          />
        </Column>
      </Row>
      <Row>
        <Column className="with-bottom-space">
          <Label attr="contactEmail" text="Email" />
          <input
            type="email"
            id="contactEmail"
            value={values.contactEmail}
            onChange={handleChange}
            required
          />
        </Column>
      </Row>
      <Row>
        <Column className="with-bottom-space">
          <Label attr="contactPhoneNumber" text="Phone Number" />
          <input
            type="text"
            id="contactPhoneNumber"
            value={values.contactPhoneNumber}
            onChange={handleChange}
            required
          />
        </Column>
      </Row>
      <Row>
        <Column className="with-bottom-space">
          <Label attr="wiringInstructions" text="Wiring Instructions" />
          <input
            type="text"
            id="wiringInstructions"
            value={values.wiringInstructions}
            onChange={handleChange}
          />
        </Column>
      </Row>
      <div className="modal-actions">
        <button className="modal-save" type="submit">
          Save
        </button>
        <button className="modal-close" onClick={onModalClose}>
          Cancel
        </button>
      </div>
    </form>
  );
};

export default EditInvoiceSettingsForm;

EditInvoiceSettingsForm.propTypes = {
  values: PropTypes.shape().isRequired,
  handleSubmit: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  onModalClose: PropTypes.func.isRequired,
  errors: PropTypes.shape(),
};

EditInvoiceSettingsForm.defaultProps = {
  errors: {},
};
